import React, {Component} from 'react';
import { localize } from 'react-localize-redux';
import { GoogleMap, withGoogleMap, withScriptjs } from 'react-google-maps';
import GoogleMarker from './GoogleMarker';

import $ from 'jquery';

class GoogleMapIcnSeverityPinList extends Component {

    constructor(props){
        super(props)

        this.getMarker = this.getMarker.bind(this);
        this.getMarkers = this.getMarkers.bind(this);

        /*
            attenzione! per utilizzare le librerie native di google ho due strade
            1- aggiungere il link nella pagina index.html
            2- utilizzare HOC withScriptjs

            e per poterle utilizzare bisogna dichiarare
            const google = window.google;
        */

    }

    componentDidMount(){

        /*
            esegue auto bounds e auto zoom
        */
        if(!this.map) return;
        if(!this.props.icnList) return;

        const google = window.google;

        var bounds = new google.maps.LatLngBounds();
        var path = [];
        $.each(this.props.icnList, function (index, item){
            var loc = new google.maps.LatLng(item.icn.latitude, item.icn.longitude  );
            path.push(loc);
            bounds.extend(loc);
        });

        // auto zoom
        this.map.fitBounds(bounds)
        //auto-center
        this.map.panToBounds(bounds);

    }

    getMarkers(google, list, isMilesPerHour, currentLanguage, translate){
        return list.map(item => (
            this.getMarker(google, item.icn, isMilesPerHour, currentLanguage, translate)
          ));
    }

    getMarker(google, icn, isMilesPerHour){
        return <GoogleMarker key={icn.id} google={google} icn={icn} isMilesPerHour={isMilesPerHour}  icnPlus={false} pdof={null} withIcnLink={true} />
    }

    render() {

        console.info("google map severity pin list rendered");

        var {translate, currentLanguage, icnList, isMilesPerHour } = this.props;
        const google = window.google;

        return (
            <div>

            <GoogleMap
                ref={(ref) => { this.map = ref; }}
                defaultZoom={12}
                defaultOptions={
                    {
                        gestureHandling: 'greedy'
                    }
                }  >
                {
                    this.getMarkers(google, icnList, isMilesPerHour, currentLanguage, translate)
                }
            </GoogleMap>
            </div>
        );
    }
}


export default withScriptjs(withGoogleMap(localize(GoogleMapIcnSeverityPinList, 'locale')));


// WEBPACK FOOTER //
// ./src/components/maps/GoogleMapIcnSeverityPinList.js